import { UserAssetPropertiesService } from "../../../services/Asset/UserAssetPropertiesService";

export class UserMediaPropertiesService extends UserAssetPropertiesService {
  get url(): string {
    return "/UserMediaProperties";
  }
}
